import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Tooltip as FluentTooltip } from "@fluentui/react-components";
// forwardRef wrapper to avoid "function components cannot be given refs" warning
// FluentTooltip handles ref forwarding to children internally via applyTriggerPropsToChildren
export const Tooltip = forwardRef((props, _ref) => {
    const { content, positioning, children } = props;
    if (!content) {
        return children;
    }
    return (_jsx(FluentTooltip, { relationship: "description", content: content, positioning: positioning, children: children }));
});
Tooltip.displayName = "Tooltip";
//# sourceMappingURL=tooltip.js.map